const currencyLocales = {
  KES: 'en-KE', UGX: 'en-UG', TZS: 'sw-TZ', RWF: 'rw-RW', NGN: 'en-NG', GHS: 'en-GH', ZAR: 'en-ZA',
  GBP: 'en-GB', EUR: 'en-IE', INR: 'en-IN', USD: 'en-US', AED: 'en-AE', AUD: 'en-AU', CAD: 'en-CA',
};

export function formatCurrency(amount = 0, currency = 'KES', locale) {
  return new Intl.NumberFormat(locale || currencyLocales[currency] || 'en-US', {
    style: 'currency',
    currency,
    maximumFractionDigits: 0,
  }).format(Number(amount || 0));
}
